(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/text-list.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/text-list.js');
"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TextList = _ref => {
  let {
    textOptions
  } = _ref;
  return React.createElement(React.Fragment, null, textOptions && Array.isArray(textOptions) && textOptions.map((_ref2, index) => {
    let {
      content,
      classes
    } = _ref2;
    if (typeof content === 'string') {
      let itemClasses;
      if (Array.isArray(classes) && classes.length > 0 && !_.find(classes, item => typeof item !== 'string')) {
        itemClasses = classes.toString().replace(/,/g, ' ');
      } else if (typeof classes === 'string') {
        itemClasses = classes;
      }
      return React.createElement("p", {
        className: "payfooter-text ".concat(itemClasses ? itemClasses : '').trim(),
        key: "".concat(content, "_").concat(index)
      }, content);
    }
    const className = content.props.className && "".concat(content.props.className, " payfooter-text") || 'payfooter-text';
    return React.createElement(content.type, _extends({
      key: "".concat(content.props.children, "_").concat(index)
    }, content.props, {
      className: className
    }), content.props.children);
  }));
};
svs.tur.ReactPayfooter.TextList = TextList;

 })(window);